import {
  Box,
  Tooltip,
  IconButton,
  Badge,
  makeStyles,
  Popover,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {
  getListAlerts,
  getListNotifications,
  getNumberNotificationUnRead,
  getVehicleNotifier,
  readAllNotificationById,
  readNotificationById,
  resetAlertList,
  resetNotificationList
} from 'src/features/notificationSlice';
import React, { useEffect, useState } from 'react';
import { NotificationList } from './NotificationList';
import { useNavigate } from 'react-router';

const useStyles = makeStyles(() => ({
  notificationBadge: {
    '& .MuiBadge-badge': {
      minWidth: 18,
      height: 18,
      padding: '0 5px',
      borderRadius: 9,
      backgroundColor: '#d9042f',
      color: '#fff',
      fontSize: 11,
      fontWeight: 700
    },
    '& .MuiBadge-anchorOriginTopRightRectangle': {
      transform: 'translate(40%, -30%)'
    }
  }
}));

const Notifier = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const params = {
    page: 1,
    page_size: 15
  };
  const [isAlertView, setIsAlertView] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const listNotification = useSelector(
    state => state.notificationSlice.listNotification
  );
  const listAlert = useSelector(state => state.notificationSlice.listAlert);
  const numUnreadNotifications = useSelector(
    state => state.notificationSlice.numUnreadNotifications
  );
  const filteredNotifications = isAlertView ? listAlert : listNotification;

  useEffect(() => {
    if (dataLogin) {
      dispatch(getNumberNotificationUnRead());
    }
  }, [dataLogin]);

  useEffect(() => {
    if (!anchorEl || !dataLogin) return;

    if (isAlertView) {
      dispatch(getListAlerts({ params, isRefresh: true }));
    } else {
      dispatch(getListNotifications({ params, isRefresh: true }));
    }
  }, [isAlertView, anchorEl]);

  const hideNotification = () => {
    setAnchorEl(null);
  };

  const showNotifications = event => {
    setAnchorEl(event.currentTarget);
  };

  const onClickNotification = notification => {
    if (!notification.is_read) {
      dispatch(readNotificationById({ id: notification._id }));
    }
    if (notification && notification.license_plate) {
      navigate('/app/tracking');
      dispatch(
        getVehicleNotifier({ license_plate: notification.license_plate })
      );
    }
    setAnchorEl(null);
  };

  const handleLoadMoreNotification = pageNext => {
    const newParam = { ...params, page: pageNext };
    if (isAlertView) {
      dispatch(getListAlerts({ params: newParam, isRefresh: false }));
    } else {
      dispatch(getListNotifications({ params: newParam, isRefresh: false }));
    }
  };

  const readAll = () => {
    const userId = dataLogin.id;
    if (userId) {
      dispatch(readAllNotificationById({ id: userId })).then(() => {
        if (isAlertView) {
          dispatch(getListAlerts({ params: params, isRefresh: true }));
        } else {
          dispatch(getListNotifications({ params: params, isRefresh: true }));
        }
        dispatch(getNumberNotificationUnRead());
      });
    }
  };

  return (
    <>
      <Tooltip title={'Thông báo'}>
        <IconButton
          onClick={showNotifications}
          edge="end"
          style={{ marginRight: '0px' }}
        >
          {numUnreadNotifications > 0 && !anchorEl ? (
            <Badge
              badgeContent={numUnreadNotifications}
              color="primary"
              variant="standard"
              className={classes.notificationBadge}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <NotificationsIcon color="primary" style={{ color: '#90a0b7' }} />
            </Badge>
          ) : (
            <NotificationsIcon color="primary" style={{ color: '#90a0b7' }} />
          )}
        </IconButton>
      </Tooltip>

      <Popover
        disableRestoreFocus
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        onClose={hideNotification}
      >        <div
        style={{
          width: isMobile ? '100%' : '516px',
          maxHeight: 'calc(100vh - 92px)',
          display: 'flex',
          flexDirection: 'column',
          color: 'white',
          backgroundColor: 'rgba(255, 145, 145, 0.25)',
          overflow: 'hidden'
        }}
      >
          <div
            style={{
              backgroundColor: '#ffffff',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '48px',
              padding: '0 16px',
              color: '#03294a',
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              border: '1px solid #e6e9ed',
              flexShrink: 0
            }}
          >
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              <Box display={'flex'} alignItems="center" py={1}>
                <Box
                  style={{
                    fontSize: isMobile ? '14px' : '20px',
                    fontWeight: 600,
                    color: !isAlertView ? '#1E2323' : '#C5C6D2',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setIsAlertView(false);
                    dispatch(resetAlertList());
                  }}
                  mr={2}
                >
                  Thông báo
                </Box>
                <Box
                  style={{
                    fontSize: isMobile ? '14px' : '20px',
                    fontWeight: 600,
                    color: isAlertView ? '#1E2323' : '#C5C6D2',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setIsAlertView(true);
                    dispatch(resetNotificationList());
                  }}
                >
                  Cảnh báo
                </Box>
              </Box>
              <Box
                onClick={() => readAll()}
                style={{
                  minWidth: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  margin: '0 10px',
                  cursor: 'pointer'
                }}
              >
                {isMobile ? 'Đánh dấu đọc tất cả' : 'Đánh dấu tất cả là đã đọc'}
              </Box>
            </Box>
          </div>
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {Boolean(anchorEl) && (
              <NotificationList
                key={isAlertView ? "alert" : "notification"}
                notifications={filteredNotifications}
                onClickNotification={onClickNotification}
                handleLoadMoreNotification={handleLoadMoreNotification}
              />
            )}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default Notifier;
